import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Navbar, Nav, Button } from "react-bootstrap";
import {
    faCalendarAlt,
    faLanguage,
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import {
    Formik,
    Field,
    Form,
    ErrorMessage,
    FieldArray,
    yupToFormErrors,
    getIn,
} from "formik";
import * as Yup from "yup";
import firebase from "firebase";
import {
    useHistory,
    useLocation,
    withRouter,
    useParams,
} from "react-router-dom";
import {
    API_BASE_URL,
    USER_EXISTS,
    STRIPE_CREATE_SESSION,
    STRIPE_RETRIEVE_SESSION,
} from "../../config/index";
import * as DeviceDetect from "react-device-detect";
import { postData, sendEmail } from "../../utils/index";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { loadState, saveState } from "../../services/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


toast.configure();

function AdminRegister(props) {
    const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
    const RegisterVaildationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        phone: Yup.string()
            .matches(phoneRegExp, "Contact No. is not valid")
            .notRequired(""),
        email: Yup.string().required("Required"),
        agreeToTandC: Yup.bool().oneOf([true], "Field must be checked"),
        pass: Yup.string()
            .min(6, "Password must be atleast 6 characters long")
            .required("Required"),
        // confirmpass: Yup.string().oneOf([Yup.ref('pass'), null], 'Passwords must match').required('Required'),
    });
    const history = useHistory();

    const currentUser = firebase.auth().currentUser;

    const [paymentDetails, setPaymentDetails] = useState(null);
    const [writingUserData, setWritingUserData] = useState(false);
    const [signing, setSigning] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const registerFormRef = useRef(null);

    const { email: emailFromURL } = useParams();

    useEffect(() => {
        firebase
            .firestore()
            .collection("/events")
            .doc("EKWsp2FDV2aWp1F6P963")
            .get()
            .then((doc) => {
                if (doc.exists) {
                    setPaymentDetails(doc.data().stripe);
                }
            });

        // Scroll registration form into view
        registerFormRef && registerFormRef.current?.scrollIntoView();
    }, []);
    // functions from igesia-platform begin here

    const _handleUpdateProfile = (
        firstName,
        lastName,
        values,
        session_id = null,
        resetForm = null
    ) => {
        console.log(values, "values");
        const authUser = firebase.auth().currentUser;

        authUser
            .updateProfile({
                displayName: `${firstName} ${lastName}`,
                photoURL:
                    "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822",
            })
            .then(() => {
                _handleSaveUser(authUser, firstName, lastName, values, session_id);
            })
            .catch((error) => console.error(error));
    };

    const _handleSaveUser = (
        authUser,
        firstName,
        lastName,
        values,
        session_id
    ) => {
        return firebase
            .firestore()
            .collection("users")
            .doc(`${authUser.uid}`)
            .set({
                displayName: authUser.displayName,
                avatar: authUser.photoURL,
                firstName: firstName,
                lastName: lastName,
                // middleName: middleName,
                email: authUser.email,
                emailVerified: authUser.emailVerified,
                phoneNumber: authUser.phoneNumber,
                providerData: JSON.parse(JSON.stringify(authUser.providerData)),
                uid: authUser.uid,
                isAnonymous: authUser.isAnonymous,
                deviceInfo: DeviceDetect.deviceDetect(),
                deviceType: DeviceDetect.deviceType,
                device: DeviceDetect.isMobile
                    ? DeviceDetect.isMobileOnly
                        ? "Mobile"
                        : "Tablet"
                    : "Desktop",
                electron: DeviceDetect.isElectron ? true : false,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(function (response) {

                toast.success(
                    "Registered Successfully",
                    {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        autoClose: 3000,
                    }
                );
                setWritingUserData(false);
                // history.push('/event/blueoceanawards2/eventconsole/')


                //const firstName = values.firstName;
                // sendEmail({
                //     to: values.email,
                //     subject:
                //         "Registration successful  - Blue Ocean Awards - 7th Edition",
                //     content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi ${firstName}, </span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You're now registered for Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Look forward <span style="line-height: 25.2px; font-size: 18px;">to</span> seeing you on May 11.&nbsp;</span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://events.igesia.co/event/blueoceanawards2/eventconsole/" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Visit Event Reception</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
                //     from: '"igesia" <noreply@igesia.co>',
                // });

            })
            .catch(function (error) {
                console.error("Error writing document: ", error);
            });
    };
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();



    // functions from igesia-platform end here

    const continueWithEmail = async (
        resetForm,
        email,
        pass,
        firstName,
        lastName,
        values
    ) => {
        try {
            setSigning(true);
            const response = await postData(`${API_BASE_URL}${USER_EXISTS}`, {
                ["email"]: email,
            });
            const { data, message, status } = response;
            if (status === 200) {
                if (data.exist) {
                    let valuesWithoutEmailAndPass = values;
                    valuesWithoutEmailAndPass.alreadyExists = true;
                    // delete valuesWithoutEmailAndPass.email;
                    delete valuesWithoutEmailAndPass.pass;
                    delete valuesWithoutEmailAndPass.confirmpass;
                    window.localStorage.setItem(
                        "values",
                        JSON.stringify(valuesWithoutEmailAndPass)
                    );
                    toast.warning("Already Registered", {
                        position: toast.POSITION.TOP_CENTER,
                        hideProgressBar: true,
                        autoClose: 3000,
                    });
                    history.push("/admin/login");
                } else {
                    const createdUser = await firebase
                        .auth()
                        .createUserWithEmailAndPassword(email, pass);
                    setWritingUserData(true);
                    createdUser.user.sendEmailVerification();

                    if (createdUser.operationType === "signIn") {
                        _handleUpdateProfile(firstName, lastName, values, null, resetForm);
                    }
                }
            }
        } catch (e) {
            console.error(e, "error in signing user");
        } finally {
            setSigning(false);
        }
    };


    const [language, setLanguage] = useState("EN");

    useEffect(() => {
        if (loadState("language")) {
            setLanguage(loadState("language"));
        } else {
            saveState("language", "EN");
        }
    }, [loadState("language")]);

    const languageText = {
        EN: {
            firstName: "First name",
            lastName: "Last name",
            emailAddress: "Email address",
            phoneNumber: "Phone number",
            password: "Password",
            required: "Required",
            optional: "Optional",
            signUp: "Sign up",
            alreadyRegistered: "Already registered? Log in",
            termsNConditions: "Terms & Conditions",
            privacyPolicy: "Privacy Policy",
            signUpToGetStarted: "Sign up to get started",
            overLine:
                "You're almost registered for this event, please login or signup for a igesia account to attend.",
            iAgree: "I agree to igesia's",
            and: "and",
            english: "English",
            french: "French",
        },

        FR: {
            firstName: "Prénom",
            lastName: "Nom de famille",
            emailAddress: "Adresse e-mail",
            phoneNumber: "Numéro de téléphone",
            password: "Mot de passe",
            required: "Obligatoire",
            optional: "Optionnel",
            signUp: "S'inscrire",
            alreadyRegistered: "Déjà enregistré? Connexion",
            termsNConditions: "Termes et Conditions",
            privacyPolicy: "Politique de confidentialité",
            signUpToGetStarted: "Inscrivez-vous pour commencer",
            overLine:
                "Vous êtes presque inscrit à cet événement, veuillez vous connecter ou vous inscrire pour un compte igesia pour y assister.",
            iAgree: "Je suis d'accord avec igesia",
            and: "et",
            english: "Anglais",
            french: "Français",
        },
    };

    const changeLanguage = (lang) => {
        setLanguage(lang);
        saveState("language", lang);
        props.callBack && props.callBack(lang);
    };

    if (!!currentUser && !writingUserData) {
        return <Redirect to="/admin" />;
    }

    return (
        <div
            className="overflow-hidden montserrat-font"
            style={{ position: "relative" }}
        >
            <div className="container-fluid bg-white" style={{}}>
                <div className="container">
                    <Navbar collapseOnSelect expand="lg" variant="light">
                        <Navbar.Brand
                            className="mx-auto"
                            href="#home"
                            // href="/"
                            target="_blank"
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/igesia-logo.png`}
                                height="70"
                            />
                        </Navbar.Brand>
                        <Dropdown className="">
                            <Dropdown.Toggle
                                as="div"
                                id="dropdown-basic"
                                style={{ cursor: "pointer" }}
                            >
                                {language === "EN" ? "Language" : "Langue"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    active={language === "EN"}
                                    onClick={() => changeLanguage("EN")}
                                >
                                    {languageText[`${language}`].english}
                                </Dropdown.Item>
                                {/* <Dropdown.Item
                                    active={language === "FR"}
                                    onClick={() => changeLanguage("FR")}
                                >
                                    {languageText[`${language}`].french}
                                </Dropdown.Item> */}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Navbar>
                </div>
            </div>

            <div
                className="container-fluid pt-3 pb-5"
                style={{ backgroundColor: "#EFEFEF" }}
            >
                <div className="container pb-4">
                    <div className="row my-5">
                        <div className="col-md-6 offset-md-3">
                            <div className="text-dark text-center p-2 mb-5 ">
                                <h3 className="mb-3">
                                    {languageText[`${language}`].signUpToGetStarted}
                                </h3>
                                <p className="mb-0 text-muted">
                                    <a href="/admin/login">
                                        {languageText[`${language}`].alreadyRegistered}
                                    </a>
                                </p>
                            </div>
                            <div className="text-dark">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/igesia-cover.jpg`}
                                    className="w-100 mb-3 rounded-12"
                                    alt="..."
                                />
                            </div>
                            <p className="small">{languageText[`${language}`].overLine}</p>
                            <Formik
                                validationSchema={RegisterVaildationSchema}
                                initialValues={{
                                    firstName: "",
                                    lastName: "",
                                    email: emailFromURL ?? "",
                                    phone: "",
                                    agreeToTandC: false,
                                    timestamp: new Date(),
                                    alreadyExists: false,
                                    pass: "",
                                    confirmpass: "",
                                }}
                                onSubmit={(values, { resetForm }) => {
                                    continueWithEmail(
                                        resetForm,
                                        values.email,
                                        values.pass,
                                        values.firstName,
                                        values.lastName,
                                        values
                                    );
                                }}
                            >
                                {({ errors, touched, isValidating, values }) => (
                                    <Form ref={registerFormRef}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className=" form-group small font-weight-bold"
                                                    controlId="fname"
                                                >
                                                    <label
                                                        htmlFor="firstName"
                                                        className="mb-1 form-label"
                                                    >
                                                        {languageText[`${language}`].firstName} (
                                                        {languageText[`${language}`].required})
                                                    </label>
                                                    <Field
                                                        name="firstName"
                                                        id="firstName"
                                                        type="text"
                                                        // placeholder="First name"
                                                        className="form-control"
                                                    ></Field>
                                                    {errors.firstName && touched.firstName ? (
                                                        <div className="text-danger ml-2 text-capitalize">
                                                            {errors.firstName}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className=" form-group small font-weight-bold"
                                                    controlId="fname"
                                                >
                                                    <label htmlFor="lastName" className="mb-1 form-label">
                                                        {languageText[`${language}`].lastName} (
                                                        {languageText[`${language}`].required})
                                                    </label>
                                                    <Field
                                                        name="lastName"
                                                        id="lastName"
                                                        type="text"
                                                        // placeholder="First name"
                                                        className="form-control"
                                                    ></Field>
                                                    {errors.lastName && touched.lastName ? (
                                                        <div className="text-danger ml-2 text-capitalize">
                                                            {errors.lastName}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className=" form-group small font-weight-bold"
                                                    controlId="fname"
                                                >
                                                    <label htmlFor="email" className="mb-1 form-label">
                                                        {languageText[`${language}`].emailAddress} (
                                                        {languageText[`${language}`].required})
                                                    </label>
                                                    <Field
                                                        name="email"
                                                        id="email"
                                                        type="email"
                                                        disabled={emailFromURL}
                                                        // placeholder="First name"
                                                        className="form-control"
                                                    ></Field>
                                                    {errors.email && touched.email ? (
                                                        <div className="text-danger ml-2 text-capitalize">
                                                            {errors.email}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div
                                                    className=" form-group small font-weight-bold"
                                                    controlId="fname"
                                                >
                                                    <label htmlFor="phone" className="mb-1 form-label">
                                                        {languageText[`${language}`].phoneNumber} (
                                                        {languageText[`${language}`].optional})
                                                    </label>
                                                    <Field
                                                        name="phone"
                                                        id="phone"
                                                        type="tel"
                                                        // placeholder="First name"
                                                        className="form-control"
                                                    ></Field>
                                                    {errors.phone && touched.phone ? (
                                                        <div className="text-danger ml-2 text-capitalize">
                                                            {errors.phone}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div
                                                    className=" form-group small font-weight-bold"
                                                    controlId="fname"
                                                >
                                                    <label htmlFor="pass" className="mb-1 form-label">
                                                        {languageText[`${language}`].password} (
                                                        {languageText[`${language}`].required})
                                                    </label>
                                                    <div className="input-group">
                                                        <Field
                                                            name="pass"
                                                            id="pass"
                                                            type={showPassword ? "text" : "password"}
                                                            // placeholder="First name"
                                                            className="form-control"
                                                        ></Field>
                                                        <div
                                                            className="input-group-append"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <span
                                                                className="input-group-text"
                                                                onClick={() => setShowPassword((prev) => !prev)}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={showPassword ? faEyeSlash : faEye}
                                                                    title={showPassword ? "Hide" : "Show"}
                                                                />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {errors.pass && touched.pass ? (
                                                        <div className="text-danger ml-2 text-capitalize">
                                                            {errors.pass}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className=" form-group small font-weight-bold"
                                            controlId="fname"
                                        >
                                            <Field
                                                name="agreeToTandC"
                                                id="agreeToTandC"
                                                type="checkbox"
                                                className="mr-2"
                                            ></Field>
                                            <label htmlFor="agreeToTandC" className="small">
                                                {languageText[`${language}`].iAgree}{" "}
                                                <a href="/terms">
                                                    {languageText[`${language}`].termsNConditions}
                                                </a>{" "}
                                                {languageText[`${language}`].and}{" "}
                                                <a href="/privacy">
                                                    {languageText[`${language}`].privacyPolicy}
                                                </a>{" "}
                                                <p className="mb-0 text-muted"> </p>
                                            </label>
                                            {errors.agreeToTandC && touched.agreeToTandC ? (
                                                <div className="text-danger ml-2 text-capitalize">
                                                    {errors.agreeToTandC}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="d-flex">
                                            <Button
                                                variant="primary"
                                                className="flex-grow-1"
                                                type="submit"
                                                disabled={signing}
                                            >
                                                {languageText[`${language}`].signUp}{" "}
                                                {signing && (
                                                    <Spinner animation="border" size="sm" color="white" />
                                                )}
                                            </Button>
                                        </div>

                                        <div className="mt-3 d-flex">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary px-3 d-block flex-grow-1"
                                                onClick={() => {
                                                    history.push("/admin/login");
                                                }}
                                            >
                                                <span>
                                                    {languageText[`${language}`].alreadyRegistered}
                                                </span>
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
}

export default AdminRegister;